import GroupEmailComposer from "./GroupEmailComposer";

export type GroupEmailSheetProps = {
  open: boolean;
  onClose(): void;
  preferredSectionId?: string;
};

export default function GroupEmailSheet({ open, onClose, preferredSectionId }: GroupEmailSheetProps) {
  return <GroupEmailComposer active={open} preferredSectionId={preferredSectionId} layout="sheet" onClose={onClose} />;
}
